import Pusher from "pusher-js";
import * as Cookies from 'js-cookie'

import store from '../store'
import config from '../../../load-config';

config.then((configValues) => {
    // Pusher.logToConsole = true;
    const token = Cookies.get('token');
    // export const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
    const pusher = new Pusher(`${configValues.VUE_APP_PUSHER_APP_KEY}`, {
        cluster: `${configValues.VUE_APP_PUSHER_APP_CLUSTER}`,
        authEndpoint: `${configValues.VUE_APP_API_URL}` + 'chat/authen',
        auth: {
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
    });

    var user = JSON.parse(localStorage.getItem('user'));
    if (user && user.id) {
        const channel = pusher.subscribe('private-chat' + user.id);
        channel.bind('MessageSent',
            function (result) {
                // store.getters.chatFromTo.push(result.message)
                store.commit("setMessageSent", result)
            }
        );
    }
});